import Attachment from '@/models/Attachment';

export default {
  attachment: new Attachment(),
  attachments: [],
};
